var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 75 62.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#5be6d5;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 75,
    height: 62.49
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_162",
    "data-name": "Groupe 162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_155",
    "data-name": "Groupe 155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_318",
    "data-name": "Trac\\xE9 318",
    className: "cls-3",
    d: "M62.26,46.74h-9a1.07,1.07,0,0,1-1.07-1.07h0a1.08,1.08,0,0,1,1.08-1.08h9A10.58,10.58,0,0,0,72.86,34h0a9.5,9.5,0,0,0-.09-1.31,10.85,10.85,0,0,0-10.95-9.27H61a1.07,1.07,0,0,1-1.07-1.07.82.82,0,0,1,0-.22A17,17,0,0,0,60,15.77a16.21,16.21,0,0,0-.81-2.9,1.07,1.07,0,0,1,.6-1.39h0a1.05,1.05,0,0,1,1.38.6s0,0,0,0a18.57,18.57,0,0,1,.92,3.28,19.07,19.07,0,0,1,.14,5.89A13,13,0,0,1,74.9,32.44,12.74,12.74,0,0,1,63.85,46.65h0a12.12,12.12,0,0,1-1.59.1Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_156",
    "data-name": "Groupe 156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_319",
    "data-name": "Trac\\xE9 319",
    className: "cls-3",
    d: "M41.33,2.29a1.08,1.08,0,0,1-1.09-1.06A1.07,1.07,0,0,1,41.19.16,19.41,19.41,0,0,1,44.68,0a1.09,1.09,0,0,1,1,1.14,1.08,1.08,0,0,1-1.13,1h0a16.05,16.05,0,0,0-3.1.1h-.13",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_157",
    "data-name": "Groupe 157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_320",
    "data-name": "Trac\\xE9 320",
    className: "cls-3",
    d: "M21.76,46.75h-9A12.75,12.75,0,0,1,0,34H0a13.79,13.79,0,0,1,.1-1.57A13,13,0,0,1,12.83,21.28a14.74,14.74,0,0,1,13.88-10.7,19.17,19.17,0,0,1,4.93-6.27,1.05,1.05,0,0,1,1.5.07h0a1.07,1.07,0,0,1-.07,1.5h0L33,6a17,17,0,0,0-4.65,6.17,1.07,1.07,0,0,1-1.05.64l-.2,0h-.19a12.55,12.55,0,0,0-12.21,9.84,1.08,1.08,0,0,1-1.05.85h-.5A10.85,10.85,0,0,0,2.21,32.7a10.61,10.61,0,0,0,9.2,11.83,11.34,11.34,0,0,0,1.3.08h9a1.07,1.07,0,0,1,.07,2.14h0Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_158",
    "data-name": "Groupe 158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_321",
    "data-name": "Trac\\xE9 321",
    className: "cls-3",
    d: "M54.62,6a1.1,1.1,0,0,1-.68-.24,15.42,15.42,0,0,0-2.59-1.7A1.07,1.07,0,0,1,51,2.6h0a1.07,1.07,0,0,1,1.4-.43,17.9,17.9,0,0,1,2.94,1.92,1.07,1.07,0,0,1,.15,1.51,1,1,0,0,1-.82.39",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_159",
    "data-name": "Groupe 159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_322",
    "data-name": "Trac\\xE9 322",
    className: "cls-3",
    d: "M37.49,62.49A16.82,16.82,0,1,1,54.3,45.67h0A16.81,16.81,0,0,1,37.49,62.49m0-31.48A14.67,14.67,0,1,0,52.16,45.68h0A14.67,14.67,0,0,0,37.49,31Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_160",
    "data-name": "Groupe 160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_323",
    "data-name": "Trac\\xE9 323",
    className: "cls-3",
    d: "M37.49,54a1.07,1.07,0,0,1-1.07-1.07h0V38.47a1.07,1.07,0,0,1,2.14,0V52.88A1.07,1.07,0,0,1,37.5,54h0Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_161",
    "data-name": "Groupe 161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_324",
    "data-name": "Trac\\xE9 324",
    className: "cls-3",
    d: "M42,44.08a1.1,1.1,0,0,1-.76-.31L37.5,40l-3.78,3.79a1.09,1.09,0,0,1-1.52,0,1.07,1.07,0,0,1,0-1.52l4.54-4.53a1.06,1.06,0,0,1,1.51,0h0l4.54,4.53a1.08,1.08,0,0,1,0,1.52,1.11,1.11,0,0,1-.77.31",
    transform: "translate(0 0)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/Cloud_upload.9b4cb51cc02f5e97e0ac72766ba43aec.svg";
export { ForwardRef as ReactComponent };